<template>
    <div style="height:540px;overflow-y:scroll;overflow-x:hidden;">
        <el-form :model="from" :rules="rules" ref="from" style="padding-left: 3%; padding-right: 8%;"
            label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="城市" prop="city_id">
                        <el-select v-model="form.city_id" size="small" style="width: 100%;"
                            :placeholder="postPlaceholder" clearable>
                            <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                :value="item.city">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="最低工资" prop="minimum_wage">
                        <el-input type="number" placeholder="请输入最低工资" size="small" style="width: 100%;"
                            v-model="form.minimum_wage">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row style="margin-left:7%">
                <el-col :span="2">
                    <div style="font-weight:700">五险</div>
                </el-col>

                <el-col :span="5">
                    <div style="font-weight:700">缴费基数</div>
                </el-col>

                <el-col :span="6">
                    <div style="font-weight:700">缴费方式</div>
                </el-col>

                <el-col :span="5">
                    <div style="font-weight:700">个人比例</div>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">养老</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%"
                        v-model="form.provideAged_base"></el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.provideAged_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.provideAged_pay_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.provideAged_proportion">
                    </el-input>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">失业</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%"
                        v-model="form.unemployment_base"></el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.unemployment_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.unemployment_pay_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.unemployment_proportion">
                    </el-input>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">工伤</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%"
                        v-model="form.industrial_injury_base"></el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.industrial_injury_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.industrial_injury_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.industrial_injury_proportion">
                    </el-input>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">医疗</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%"
                        v-model="form.medical_care_base"></el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.medical_care_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.medical_care_pay_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.medical_care_proportion">
                    </el-input>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">生育</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%" v-model="form.birth_base">
                    </el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.birth_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.birth_pay_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.birth_proportion"></el-input>
                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">大额医疗</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%"
                        v-model="form.large_treatment_base"></el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.large_treatment_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.large_treatment_pay_type" label="1" style="margin-left:-20px">固定缴费
                    </el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.large_treatment_proportion">
                    </el-input>
                </el-col>

                <el-col :span="6">
                    <div style="">
                        医保大额扣费月份
                        <el-select v-model="form.large_treatment_month" size="small"
                            style="width: 42%;margin-left: 5px;" :placeholder="postPlaceholder" clearable>
                            <el-option v-for="item in monthList" :key="item.label" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </div>

                </el-col>
            </el-row>

            <el-row style="margin:3% 0 0 7%">
                <el-col :span="2">
                    <div style="">公积金</div>
                </el-col>

                <el-col :span="5">
                    <el-input type="number" size="mini" placeholder="" style="width:80%" v-model="form.commonMpe_base">
                    </el-input>
                </el-col>

                <el-col :span="6">
                    <el-radio v-model="form.commonMpe_pay_type" label="0">比例缴费</el-radio>
                    <el-radio v-model="form.commonMpe_pay_type" label="1" style="margin-left:-20px">固定缴费</el-radio>
                </el-col>

                <el-col :span="5">
                    <el-input size="mini" placeholder="" style="width:80%" v-model="form.commonMpe_proportion">
                    </el-input>
                </el-col>
            </el-row>

            <el-row style="margin:5% 0 0 10%">
                <el-col :span="6">
                    <div style="font-weight:700">公司缴费比例</div>
                </el-col>
            </el-row>

            <el-row style="margin-left:10%;margin-top:2%">
                <el-col :span="5">
                    <div style="font-weight:700">公司</div>
                </el-col>
                <el-col :span="2" style="margin-left:3%">
                    <div style="font-weight:700">养老</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">失业</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">工伤</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">医疗</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">生育</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">大额医疗</div>
                </el-col>
                <el-col :span="2" style="margin-left:1%">
                    <div style="font-weight:700">公积金</div>
                </el-col>
            </el-row>

            <el-row style="margin:1% 0 0 10%" v-for="(item, index) in form.companyCount" :key="index">
                <el-from :model="form.companyList[index]" ref="rangeRuleForm">
                    <el-col :span="5">
                        <el-select v-model="form.companyList[index].pay_company" style="width:100%" placeholder="请选择"
                            size="small" clearable>
                            <el-option v-for="item in partnerList" :key="item.id" :label="item.partner_abbreviation"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2" style="margin-left:3%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_provideAged"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_unemployment"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_industrial_injury"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_medical_care"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_birth"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_large_treatment"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:1%">
                        <el-input size="small" placeholder="" style="width:90%;"
                            v-model="form.companyList[index].pay_commonMpe"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left:2%">
                        <img src="../../../assets/icon/添加.png" style="height: 25px; margin-left: 3%; margin-top: 5px;"
                            v-show="(index + 1) == form.companyCount.length" @click="AddRecord" />
                        <img src="../../../assets/icon/减少.png" style="height: 25px; margin-left: 10px; margin-top: 5px;"
                            v-show="index != 0" @click="RemoveRecord(index)" />
                    </el-col>
                </el-from>
            </el-row>
        </el-form>
        <el-button type="goon" @click="add()" style="margin:3% 0 0 45%">确 定</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            radio: '1',
            // 公司缴费比例
            rangeListIndex: 1,
            //公司数据
            partnerList: [],
            monthList: [{
                label: "1"
            }, {
                label: "2"
            }, {
                label: "3"
            }, {
                label: "4"
            }, {
                label: "5"
            }, {
                label: "6"
            }, {
                label: "7"
            }, {
                label: "8"
            }, {
                label: "9"
            }, {
                label: "10"
            }, {
                label: "11"
            }, {
                label: "12"
            }],
            form: {
                city_id: '',
                minimum_wage: '',
                // 养老
                provideAged_base: '',
                provideAged_pay_type: '',
                provideAged_proportion: '',
                // 失业
                unemployment_base: '',
                unemployment_pay_type: '',
                unemployment_proportion: '',
                // 工伤
                industrial_injury_base: '',
                industrial_injury_type: '',
                industrial_injury_proportion: '',
                // 医疗
                medical_care_base: '',
                medical_care_pay_type: '',
                medical_care_proportion: '',
                // 生育
                birth_base: '',
                birth_pay_type: '',
                birth_proportion: '',
                // 大额医疗
                large_treatment_base: '',
                large_treatment_pay_type: '',
                large_treatment_proportion: '',
                large_treatment_month: '',
                // 公积金
                commonMpe_base: '',
                commonMpe_pay_type: '',
                commonMpe_proportion: '',
                // 公司缴费比例
                companyList: [{
                    pay_company: '',
                    pay_provideAged: '',
                    pay_unemployment: '',
                    pay_industrial_injury: '',
                    pay_medical_care: '',
                    pay_birth: '',
                    pay_large_treatment: '',
                    pay_commonMpe: '',
                    flag: 0
                }],
                companyCount: [1],
            }
        };
    },
    methods: {
        //添加记录
        AddRecord() {
            // this.rangeListIndex += 1;
            // this.$set(this.form.companyList, this.form.companyList.length, {
            this.form.companyCount.push(1);
            this.form.companyList.push({
                pay_company: "",
                pay_provideAged: "",
                pay_unemployment: "",
                pay_industrial_injury: "",
                pay_medical_care: "",
                pay_birth: "",
                pay_large_treatment: "",
                pay_commonMpe: "",
                flag: this.form.companyList.length,
            });
        },
        //移除记录
        RemoveRecord(e) {
            // this.rangeListIndex -= 1;
            // this.form.companyList.splice(e, 1);
            this.form.companyCount.splice(e, 1);
            this.form.companyList.splice(e, 1);
        },
        async add() {
            var url = '/InsuranceBase/insert';
            var record = {
                city_id: this.form.city_id,
                minimum_wage: this.form.minimum_wage,
                // 养老
                provideAged_base: this.form.provideAged_base,
                provideAged_pay_type: this.form.provideAged_pay_type,
                provideAged_proportion: this.form.provideAged_proportion,
                // 失业
                unemployment_base: this.form.unemployment_base,
                unemployment_pay_type: this.form.unemployment_pay_type,
                unemployment_proportion: this.form.unemployment_proportion,
                // 工伤
                industrial_injury_base: this.form.industrial_injury_base,
                industrial_injury_type: this.form.industrial_injury_type,
                industrial_injury_proportion: this.form.industrial_injury_proportion,
                // 医疗
                medical_care_base: this.form.medical_care_base,
                medical_care_pay_type: this.form.medical_care_pay_type,
                medical_care_proportion: this.form.medical_care_proportion,
                // 生育
                birth_base: this.form.birth_base,
                birth_pay_type: this.form.birth_pay_type,
                birth_proportion: this.form.birth_proportion,
                // 大额医疗
                large_treatment_base: this.form.large_treatment_base,
                large_treatment_pay_type: this.form.large_treatment_pay_type,
                large_treatment_proportion: this.form.large_treatment_proportion,
                large_treatment_month: this.form.large_treatment_month,
                // 公积金
                commonMpe_base: this.form.commonMpe_base,
                commonMpe_pay_type: this.form.commonMpe_pay_type,
                commonMpe_proportion: this.form.commonMpe_proportion,
                // 公司缴费比例
                companyList: this.form.companyList,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.$message.success(data);
                    this.Return();
                    this.qingkongson();
                } else {
                    this.$message.warning(data);
                }
            }
        },
        Return() {
            this.qingkongson();
            this.$parent.$parent.Return();
        },

        qingkongson() {
            // 公司缴费比例
            this.form.companyList = [{}];
            this.form.companyCount=[1];
            // this.form.companyList = [{
            // 				pay_company: '',
            // 				pay_provideAged: '',
            // 				pay_unemployment: '',
            // 				pay_industrial_injury: '',
            // 				pay_medical_care: '',
            // 				pay_birth: '',
            // 				pay_large_treatment: '',
            // 				pay_commonMpe: '',
            // 				flag: 0
            // 			}];
            // this.form.companyList.pay_company = '';
            // this.form.companyList.pay_provideAged = '';
            // this.form.companyList.pay_unemployment = '';
            // this.form.companyList.pay_industrial_injury = '';
            // this.form.companyList.pay_medical_care = '';
            // this.form.companyList.pay_birth = '';
            // this.form.companyList.pay_large_treatment = '';
            // this.form.companyList.pay_commonMpe = '';
            // this.form.companyList.flag = 0;
            this.form.city_id = '';
            this.form.minimum_wage = '';
            // 养老
            this.form.provideAged_base = '';
            this.form.provideAged_pay_type = '';
            this.form.provideAged_proportion = '';
            // 失业
            this.form.unemployment_base = '';
            this.form.unemployment_pay_type = '';
            this.form.unemployment_proportion = '';
            // 工伤
            this.form.industrial_injury_base = '';
            this.form.industrial_injury_type = '';
            this.form.industrial_injury_proportion = '';
            // 医疗
            this.form.medical_care_base = '';
            this.form.medical_care_pay_type = '';
            this.form.medical_care_proportion = '';
            // 生育
            this.form.birth_base = '';
            this.form.birth_pay_type = '';
            this.form.birth_proportion = '';
            // 大额医疗
            this.form.large_treatment_base = '';
            this.form.large_treatment_pay_type = '';
            this.form.large_treatment_proportion = '';
            this.large_treatment_month = '';
            // 公积金
            this.form.commonMpe_base = '';
            this.form.commonMpe_pay_type = '';
            this.form.commonMpe_proportion = '';
        }
    },
    async created() {
        // this.form = this.$parent.$parent.form;
        // 公司
        // this.form = {
        //     city_id: '',
        //     minimum_wage: '',
        //     // 养老
        //     provideAged_base: '',
        //     provideAged_pay_type: '',
        //     provideAged_proportion: '',
        //     // 失业
        //     unemployment_base: '',
        //     unemployment_pay_type: '',
        //     unemployment_proportion: '',
        //     // 工伤
        //     industrial_injury_base: '',
        //     industrial_injury_type: '',
        //     industrial_injury_proportion: '',
        //     // 医疗
        //     medical_care_base: '',
        //     medical_care_pay_type: '',
        //     medical_care_proportion: '',
        //     // 生育
        //     birth_base: '',
        //     birth_pay_type: '',
        //     birth_proportion: '',
        //     // 大额医疗
        //     large_treatment_base: '',
        //     large_treatment_pay_type: '',
        //     large_treatment_proportion: '',
        //     large_treatment_month: '',
        //     // 公积金
        //     commonMpe_base: '',
        //     commonMpe_pay_type: '',
        //     commonMpe_proportion: '',
        //     // 公司缴费比例
        //     companyList: [{
        //         pay_company: '',
        //         pay_provideAged: '',
        //         pay_unemployment: '',
        //         pay_industrial_injury: '',
        //         pay_medical_care: '',
        //         pay_birth: '',
        //         pay_large_treatment: '',
        //         pay_commonMpe: '',
        //         flag: 0
        //     }],
        // }
        var partnerList = await this.$globals.AxiosPost("partner/selectFind", {});
        this.partnerList = partnerList.data;
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// Bxjsgl_add.vue?22a1c3f0